import {
  dedereCompanyIds
} from 'application/src/js/globals.js';

import {
  Mediator
} from 'application/src/js/util.js';

/**
 * @description Controller class for the clicks history list
 * @param {DataStorage} args.store - DataStorage instance
 * @param {object} args.translations - text translations
 * @param {ContactDetailsModal} args.contactDetailsModal - ContactDetailsModal instance
 * @param {Pagination} args.pagination - Pagination instance
 */
export default class SingleClicksList extends Mediator {
  constructor(args) {
    super(args);
    this.store = args.store;
    this.translations = args.translations;
    this.contactDetailsModal = args.contactDetailsModal;
    this.pagination = args.pagination;
    this.outerContainer = document.querySelector('.single-clicks-list');
    this.exportButton = document.querySelector('.clicks-list .export-file');
    this.listContentElement = this.outerContainer.querySelector('.list-content');
    this.listHead = this.outerContainer.querySelector('.list-head');
    this.sortTrigger = this.listHead.querySelectorAll('[data-sort]');

    this.statisticsStepsIdFilterDropdown = args.statisticsStepsIdFilterDropdown;
    this.statisticsStepIdFilter = this.listHead.querySelectorAll('.action input');

    this.hideClass = 'hide';
    this.sortField = 'statistics_datetime';
    this.sortDir = 'desc';
    this.perPage = 15;
    this.pageIndex = 0;

    this.addEvents();
  }

  addEvents() {
    ['init', 'update'].map(eventType => {
      this.store.subscribe(eventType, state => {
        this.data = Object.assign({}, state.list);
        this.pageIndex = this.pagination.update(state.completeList.clicks.length, this.perPage);
        this.listContentElement.classList[this.data.clicks.length ? 'remove' : 'add'](this.hideClass);
        this.render();
      });
    });

    /**
     * filter by statistics_step_id
     * 1 - contractoffer
     * 2 - dynamicoffer
     * 3 - mailing-click
     * 4 - mailing-open
     * 5 - news-click
     * 6 - news-open
     * 7 - request-click
     * 8 - chart
     */
    [...this.statisticsStepIdFilter].map(checkbox => {
      checkbox.addEventListener('change', e => {
        this.stepIdsChanged = true;
      });
    });

    this.statisticsStepsIdFilterDropdown.subscribe('close', e => {
      if (this.stepIdsChanged) {
        this.publish('reloadList', this.perPage, this.pageIndex, this.sortField, this.sortDir, this.statisticsStepIds);
        this.stepIdsChanged = false;
      }
    });

    [...this.sortTrigger].map(trigger => {
      trigger.addEventListener('click', e => {
        const prevTrigger = this.listHead.querySelector(`[data-sort="${this.sortField}"]`);
        prevTrigger.classList.remove(this.sortDir);

        if (trigger.isEqualNode(prevTrigger)) {
          this.sortDir = this.sortDir == 'desc' ? 'asc' : 'desc';
        } else {
          this.sortDir = 'desc';
          prevTrigger.classList.remove('sort');
          trigger.classList.add('sort');
        }

        trigger.classList.add(this.sortDir);
        this.sortField = trigger.getAttribute('data-sort');

        this.publish('action', this.perPage, this.pageIndex, this.sortField, this.sortDir, this.statisticsStepIds);
      });
    });

    if (this.exportButton) {
      this.exportButton.addEventListener('click', e => {
        e.preventDefault();
        const button = document.createElement('a');
        button.setAttribute('href', 'ajaxClickDetailsContactExport');
        button.setAttribute('display', 'display:none!important');
        button.innerHTML = '&nbsp';
        document.body.insertAdjacentElement('beforeend', button);
        button.click();
        button.parentNode.removeChild(button);
      });
    }

    this.pagination.subscribe('pageChange', pageIndex => {
      this.pageIndex = pageIndex;
      if (window.pageYOffset > this.outerContainer.offsetTop) {
        this.outerContainer.scrollIntoView();
      }
      this.publish('action', this.perPage, this.pageIndex, this.sortField, this.sortDir, this.statisticsStepIds);
    });
  }

  get statisticsStepIds() {
    return [...this.statisticsStepIdFilter].reduce((values, cb) => {
      if (cb.checked) values.push(parseInt(cb.value));
      return values;
    }, []);
  }

  render() {
    this.listContentElement.innerHTML = '';

    this.data.clicks.map(clicksRowData => {
      const rowElement = document.createElement('div');
      this.listContentElement.insertAdjacentElement('beforeend', rowElement)

      new ClicksRow({
        parent: this,
        translations: this.translations,
        element: rowElement,
        data: clicksRowData,
        store: this.store,
        contactDetailsModal: this.contactDetailsModal
      });
    });
  }
}

/**
 * class representing a single statistics row
 * @param {SingleClicksList} args.parent - the instance of SingleClicksList
 * @param {object} args.translations - text translations
 * @param {node} args.element - the row element
 * @param {object} args.data - the json data
 */
class ClicksRow {
  constructor(args) {
    this.parent = args.parent;
    this.translations = args.translations;
    this.element = args.element;
    this.data = args.data;
    this.store = args.store;
    this.element.setAttribute('data-step-entry', this.data.statistics_step_entry_id);
    this.contactDetailsModal = args.contactDetailsModal;

    this.render();
  }

  render() {
    this.element.innerHTML = this.template;
    this.element.classList.add('list-row');
    this.showInfoButton = this.element.querySelector('.show-contact-info');

    this.addEvents();
  }

  addEvents() {
    if (this.showInfoButton) {
      this.showInfoButton.addEventListener('click', e => {
        this.contactDetailsModal.show(this.data.global_address_contact_id, this.data.company_user_id, this.data.global_address_id);
      });
    }
  }

  get isDedere() {
    const state = this.store.getState();
    return state.user && dedereCompanyIds.includes(state.user.company_id);
  }

  get canAccessDetails() {
    return this.data.name ? this.data.name.indexOf('* *') === -1 : true;
  }

  get nameColumn() {
    let userName = this.translations.unknown;

    if (this.data.lastname || this.data.firstname) {
      userName = `${this.data.lastname ? this.data.lastname + ', ' : ''}${this.data.firstname ? this.data.firstname : ''}`;
    } else {
      if (this.data.user_lastname || this.data.user_firstname) {
        userName = `${this.data.user_lastname ? this.data.user_lastname + ', ' : ''}${this.data.user_firstname ? this.data.user_firstname : ''}`;
      }
    }

    return `
      <div class="name">
        ${this.data.global_address_contact_id || this.data.global_address_id ? `
          <a class="show-contact-info" title="${this.translations.showContactInfo}">${userName}</a>
        ` : userName}
      </div>
    `
  }

  get companyColumn() {
    if (this.canAccessDetails) {
      return this.data.name ? `
        <div class="company">
          ${this.data.global_address_id ? `
            <a href="/mundus-agri/addressDetails/${this.data.global_address_id}" title="${this.translations.goToCompany}">
              ${this.data.name}
            </a>
          ` : this.data.name}
        </div>` : `<div>${this.translations.unknown}</div>`;
    } else {
      return `<div class="company"><span class="no-access">${this.data.name || '* * * * *'}</span></div>`;
    }
  }

  get providerColumn() {
    return this.data.news_company_name ? `<div class="provider">${this.data.news_company_name}</div>` : `<div class="provider empty"></div>`;
  }

  get valueAddedStepColumn() {
    return this.data.global_value_added_step_id ? `<div class="value-added-step">${this.translations.valueAddedSteps[this.data.global_value_added_step_id]}</div>` : `<div class="value-added-step empty"></div>`;
  }

  get countryColumn() {
    return this.data.global_address_id && this.data.country_short ? `
      <div class="country">
        <div>
          <img src="/projects/application/dist/images/icons/flags/4x3/${this.data.country_short.toLowerCase()}.svg" alt="${this.data.country_name}" title="${this.data.country_name}"> <span>${this.data.country_name}</span>
        </div>
      </div>
    ` : `<div class="country empty"></div>`;
  }

  get dateColumn() {
    return this.data.statistics_datetime ? `<div class="date">${this.data.statistics_datetime}</div>` : `<div class="date empty"></div>`;
  }

  get title() {
    switch (this.data.statistics_step_id) {
      // news
      case 5:
        return this.data.title;

        // offer / request
      default:
        return `${this.data.basicname} ${this.data.typename}`;
    }
  }

  get buttonColumn() {
    return `
      <div class="action">
        <span>${this.translations.wasInterestedIn}:</span>
        <a
          href="${this.data.target_url ? this.data.target_url : ''}"
          title="${this.data.title ? this.data.title.replace('"', '&quot;') : this.translations.clickTarget[this.data.statistics_step_id]}"
        >
          <b>${this.translations.clickTarget[this.data.statistics_step_id]}:</b> ${this.title}
        </a>
      </div>
    `;
  }

  get template() {
    return `
      ${this.dateColumn}
      ${this.isDedere ? this.nameColumn : ''}
      ${this.companyColumn}
      ${this.valueAddedStepColumn}
      ${this.countryColumn}
      ${this.providerColumn}
      ${this.buttonColumn}
    `;
  }
}